import { UI } from "@/data/content";
import { lenisRef } from "@/lib/lenis";

const Monogram = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" data-testid="nav-logo" aria-label="Pia Dolesch">
    <rect width="34" height="34" rx="4" fill="#7E2438" />
    <text x="17" y="23" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="15" fill="#F4EFEA" fontStyle="italic">PD</text>
  </svg>
);

export default function Navbar({ lang, setLang }) {
  const t = UI[lang];
  const go = (id) => (e) => {
    e.preventDefault();
    lenisRef.current?.scrollTo(id, { offset: 0, duration: 1.6 });
  };
  return (
    <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50 border-b border-[#7E2438]/25 bg-[#0D0809]/70 backdrop-blur-md">
      <div className="flex items-center justify-between px-6 sm:px-12 h-16">
        <a href="#top" onClick={go("#top")} className="flex items-center gap-3">
          <Monogram />
          <span className="font-serif text-base text-[#F4EFEA] hidden sm:block">Pia Dolesch</span>
        </a>
        <nav className="hidden md:flex items-center gap-8 font-mono text-[11px] tracking-[0.2em] uppercase text-[#A89A9E]">
          <a data-testid="nav-story" href="#story" onClick={go("#story")} className="hover:text-[#B03A52] transition-colors">{t.story}</a>
          <a data-testid="nav-works" href="#works" onClick={go("#works")} className="hover:text-[#B03A52] transition-colors">{t.works}</a>
          <a data-testid="nav-about" href="#about" onClick={go("#about")} className="hover:text-[#B03A52] transition-colors">{t.about}</a>
          <a data-testid="nav-contact" href="#contact" onClick={go("#contact")} className="hover:text-[#B03A52] transition-colors">{t.contactNav}</a>
        </nav>
        <div className="flex items-center gap-1 border border-[#7E2438]/25 rounded-full p-1">
          {["fr", "de", "en"].map((code) => (
            <button
              key={code}
              data-testid={`nav-lang-${code}`}
              onClick={() => setLang(code)}
              className={`px-3 py-1 rounded-full font-mono text-[11px] tracking-[0.15em] uppercase transition-colors duration-300 ${
                lang === code ? "bg-[#7E2438] text-[#F4EFEA]" : "text-[#A89A9E] hover:text-[#F4EFEA]"
              }`}
            >
              {code}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
